import state from './network.state'
import mutations from './network.mutations'
import actions from './network.actions'
import getters from './network.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/network/network.module.js
// module id = null
// module chunks = 